import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-purchase.component'

import ManagePurchaseNavbar from '../common/manage-purchase-navbar'
import ManagePurchaseTopblock from '../common/manage-purchase-topblock'
import InfosProduct         from './infos-product'
import BuyProduct           from './buy-product'

let module = angular.module('myPurchase', [
  uiRouter,
  ManagePurchaseNavbar,
  ManagePurchaseTopblock,
  InfosProduct,
  BuyProduct
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('managePurchase.myPurchase', {
      url: '/mypurchase/:productId',
      component: 'myPurchase',
      authenticate: true
    })
})

.component('myPurchase', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/index.js